import { render, staticRenderFns } from "./tableSetting.vue?vue&type=template&id=8f146e6c&scoped=true&"
import script from "./tableSetting.vue?vue&type=script&lang=js&"
export * from "./tableSetting.vue?vue&type=script&lang=js&"
import style0 from "./tableSetting.vue?vue&type=style&index=0&id=8f146e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f146e6c",
  null
  
)

export default component.exports